// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WFof","label":"styles_label__U43K3"};